import { render, staticRenderFns } from "./TechStartupResumeGuide.vue?vue&type=template&id=0b9d97e6&"
import script from "./TechStartupResumeGuide.vue?vue&type=script&lang=js&"
export * from "./TechStartupResumeGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports